import commeDesGarconsHommePlus2022ssFlowerExistence from "./comme-des-garcons-homme-plus-2022ss-flower-existence";
import commeDesGarconsHommePlus2020ssOrlando from "./comme-des-garcons-homme-plus-2020ss-orlando";
import commeDesGarconsLineGuide from "./comme-des-garcons-line-guide";
import maisonMargielaNumberTagGuide from "./maison-margiela-number-tag-guide";
import diorHommeHediSlimaneArchiveGuide from "./dior-homme-hedi-slimane-archive-guide";
import miucciaPradaArchiveGuide from "./miuccia-prada-archive-guide";
import yohjiYamamotoBrotherYakuzaSuitGuide from "./yohji-yamamoto-brother-yakuza-suit-guide";
import commeDesGarcons1997ssBodyMeetsDressGuide from "./comme-des-garcons-1997ss-body-meets-dress-guide";
import commeDesGarcons1982awHolesDestroyGuide from "./comme-des-garcons-1982aw-holes-destroy-guide";
import commeDesGarcons2005awBrokenBrideGuide from "./comme-des-garcons-2005aw-broken-bride-guide";
import commeDesGarcons2015ssRosesAndBloodGuide from "./comme-des-garcons-2015ss-roses-and-blood-guide";
import commeDesGarcons2012aw2DimensionsGuide from "./comme-des-garcons-2012aw-2-dimensions-guide";
import sacaiHybridAestheticGuide from "./sacai-hybrid-aesthetic-guide";
import commeDesGarconsHommePlus2023ssAnotherKindOfPunkGuide from "./comme-des-garcons-homme-plus-2023ss-another-kind-of-punk-guide";
import commeDesGarconsHommePlus2026ssNotSuitsButSuitsGuide from "./comme-des-garcons-homme-plus-2026ss-not-suits-but-suits-guide";
import commeDesGarconsHommePlus2025awToHellWithWarGuide from "./comme-des-garcons-homme-plus-2025aw-to-hell-with-war-guide";
import commeDesGarconsHommePlus2024ssBeyondRealityGuide from "./comme-des-garcons-homme-plus-2024ss-beyond-reality-guide";
import junyaWatanabeMan2025ssDressUpDenimGuide from "./junya-watanabe-man-2025ss-dress-up-denim-guide";
import junyaWatanabeMan2023awInnerraumArchiveReproductGuide from "./junya-watanabe-man-2023aw-innerraum-archive-reproduct-guide";
import commeDesGarcons2018ssMultiDimensionalGraffitiGuide from "./comme-des-garcons-2018ss-multi-dimensional-graffiti-guide";
import commeDesGarcons2019ssQuietCollectionCuttingGuide from "./comme-des-garcons-2019ss-quiet-collection-cutting-guide";
import helmutLangHistoryMinimalismMasterpiecesGuide from "./helmut-lang-history-minimalism-masterpieces-guide"

export const COLLECTIONS = {
  flower: commeDesGarconsHommePlus2022ssFlowerExistence,
  orlando: commeDesGarconsHommePlus2020ssOrlando,
  cdgLineGuide: commeDesGarconsLineGuide,
  maisonMargielaNumberTagGuide: maisonMargielaNumberTagGuide,
  diorHommeHediSlimaneGuide: diorHommeHediSlimaneArchiveGuide,
  miucciaPradaArchiveGuide: miucciaPradaArchiveGuide,
  yohjiYamamotoBrotherYakuzaSuitGuide: yohjiYamamotoBrotherYakuzaSuitGuide,
  commeDesGarcons1997ssBodyMeetsDressGuide:
    commeDesGarcons1997ssBodyMeetsDressGuide,
  commeDesGarcons1982awHolesDestroyGuide:
    commeDesGarcons1982awHolesDestroyGuide,
  commeDesGarcons2005awBrokenBrideGuide: commeDesGarcons2005awBrokenBrideGuide,
  commeDesGarcons2015ssRosesAndBloodGuide:
    commeDesGarcons2015ssRosesAndBloodGuide,
  commeDesGarcons2012aw2DimensionsGuide: commeDesGarcons2012aw2DimensionsGuide,
  sacaiHybridAestheticGuide: sacaiHybridAestheticGuide,
  commeDesGarconsHommePlus2023ssAnotherKindOfPunkGuide: commeDesGarconsHommePlus2023ssAnotherKindOfPunkGuide,
  commeDesGarconsHommePlus2026ssNotSuitsButSuitsGuide: commeDesGarconsHommePlus2026ssNotSuitsButSuitsGuide,
  commeDesGarconsHommePlus2025awToHellWithWarGuide: commeDesGarconsHommePlus2025awToHellWithWarGuide,
  commeDesGarconsHommePlus2024ssBeyondRealityGuide: commeDesGarconsHommePlus2024ssBeyondRealityGuide,
  junyaWatanabeMan2025ssDressUpDenimGuide: junyaWatanabeMan2025ssDressUpDenimGuide,
  junyaWatanabeMan2023awInnerraumArchiveReproductGuide:junyaWatanabeMan2023awInnerraumArchiveReproductGuide,
  commeDesGarcons2018ssMultiDimensionalGraffitiGuide: commeDesGarcons2018ssMultiDimensionalGraffitiGuide,
  commeDesGarcons2019ssQuietCollectionCuttingGuide: commeDesGarcons2019ssQuietCollectionCuttingGuide,
  helmutLangHistoryMinimalismMasterpiecesGuide: helmutLangHistoryMinimalismMasterpiecesGuide
};
